import {
  collection,
  getFirestore,
  limit,
  onSnapshot,
  orderBy,
  query,
} from 'firebase/firestore';

function timestampToMs(value) {
  if (!value) return null;
  if (typeof value === 'number') return value;
  if (typeof value.toMillis === 'function') return value.toMillis();
  if (value.seconds) return value.seconds * 1000;
  return Date.parse(value) || null;
}

export default function listenTestStandLogs(onData, onError, { maxCount = 50 } = {}) {
  const q = query(
    collection(getFirestore(), 'test_stand_logs'),
    orderBy('createdAt', 'desc'),
    limit(maxCount),
  );
  return onSnapshot(
    q,
    (snap) => {
      const runs = snap.docs.map((doc) => {
        const data = doc.data();
        return {
          runId: doc.id,
          ...data,
          createdAt: timestampToMs(data.createdAt),
          updatedAt: timestampToMs(data.updatedAt),
          startedAt: timestampToMs(data.startedAt),
          stoppedAt: timestampToMs(data.stoppedAt),
        };
      });
      onData(runs);
    },
    onError,
  );
}
